/* global __webpack_public_path__ */
import preact from 'preact'
import 'preact/debug' // condition in this file prevents it from usage outside of dev env
import tracker from '../components/tracker/publish'
import detectLogout from '../utils/detectLogout'
import globals from '../utils/globals'
import { addTranslationDict } from 'libs/translationsUtils/translations'
import loadScript from 'load-script'

import axios from 'axios'

axios.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest'
}

if (typeof window.CustomEvent !== 'function') require('../utils/customEventPolyfill')
if (!global._babelPolyfill) require('@babel/polyfill')
// eslint-disable-next-line no-undef
if (typeof NodeList.prototype.forEach !== 'function') {
  require('../utils/forEachPolyfill').default()
}

detectLogout()

var scriptElement = document.getElementById('insided-preact-app')
if (scriptElement) {
  globals('region', scriptElement.getAttribute('data-region'))
  globals('environment', scriptElement.getAttribute('data-environment'))
  globals('communityId', scriptElement.getAttribute('data-communityId'))
  globals('activeModules', scriptElement.getAttribute('data-modules'))
  globals('communityUrl', scriptElement.getAttribute('data-communityUrl'))
  globals('application', scriptElement.getAttribute('data-application'))
  globals('communityLanguage', document.getElementsByTagName('html')[0].getAttribute('lang'))
  const basePath = scriptElement.getAttribute('data-basepath')
  if (basePath) {
    __webpack_public_path__ = basePath.replace(/\/js\/$/, '/') // eslint-disable-line
  }
}

window.insided = {
  initialiseComponent: function (componentName, el, params = {}, unrender = false) {
    if (unrender) {
      preact.render('', el, el.firstChild)
      return
    }
    let Component
    try {
      Component = require('preact-components/' + componentName + '.js').default
    } catch (err) {
      if (err.code !== 'MODULE_NOT_FOUND') throw err
      Component = require('preact-components/' + componentName + '.tsx').default
    }
    addTranslationDict(params.phrases || params.translations)
    params.parentEl = el
    preact.render(<Component {...params} />, el, el.firstChild)
  },
  trackEvent: tracker.trackEvent
}

function highlightCodeBlocks (wrapperComponent) {
  const codeComponentsToHighlight = wrapperComponent.querySelectorAll('pre code')
  if (codeComponentsToHighlight.length) {
    let link = document.createElement('link')
    link.href = __webpack_public_path__ + 'ckeditor/plugins/codesnippet/lib/highlight/styles/github.css'
    link.rel = 'stylesheet'
    document.head.appendChild(link)

    loadScript(__webpack_public_path__ + 'ckeditor/plugins/codesnippet/lib/highlight/highlight.pack.js', () => {
      codeComponentsToHighlight.forEach((block) => {
        window.hljs.highlightBlock(block)
      })
    })
  }
}

function prepareSpoilersAndQuotes (wrapperComponent) {
  wrapperComponent.querySelectorAll('content-spoiler, content-quote').forEach(content => {
    if (!content.getAttribute('data-prepared')) {
      let el = document.createElement('div')
      let childrenWrapper = document.createElement('div')
      childrenWrapper.className = content.tagName.toLowerCase()
      while (content.firstChild) {
        const el = content.removeChild(content.firstChild)
        childrenWrapper.appendChild(el)
      }
      content.appendChild(el)
      content.appendChild(childrenWrapper)

      content.setAttribute('data-prepared', 'true')
    }
  })
}

function instantiatePreactComponents (wrapperComponent) {
  let components = wrapperComponent.querySelectorAll('[data-preact], user-mention, content-quote, content-spoiler, oembed')

  for (let el of components) {
    try {
      window.insided.initialiseComponent(
        el.dataset.preact || (el.tagName.toLowerCase() + '/index'),
        el,
        el.dataset.props ? JSON.parse(el.dataset.props) : { ...el.dataset, content: el.innerHTML }
      )
    } catch (error) {
      console.log(error)
    }
  }
}

/*
  Dynamically requires components from HTML elements
  Usage example:
  <div
    data-preact="content-helpfulness/ContentHelpfulnessManager"
    data-props="{{ configuration | json_encode }}">
  </div>
 */

window.insided.bindPreactComponents = (wrapperComponent) => {
  prepareSpoilersAndQuotes(wrapperComponent)

  wrapperComponent.querySelectorAll('oembed').forEach(content => {
    content.dataset.url = content.getAttribute('url')
  })

  instantiatePreactComponents(wrapperComponent)

  highlightCodeBlocks(wrapperComponent)
}

window.insided.bindPreactComponents(document)
